import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { CrudService } from 'src/core/services/crud/crud.service';
import { resolveUrl, API_PREFIX } from 'src/core/constants/api.constants';

const CRM_SEGMENT = `${API_PREFIX}/crm-segment-definition`;

@Injectable({
  providedIn: 'root',
})
export class CrmSegmentDefinitionService {
  private readonly crudService = inject(CrudService);
  private readonly http = inject(HttpClient);

  getLinkedContactCount(id: number): Observable<number> {
    return this.http.get<number>(resolveUrl(`${CRM_SEGMENT}/${id}/assigned-contact-count`));
  }

  checkNameUnique(name: string, excludedId?: number): Observable<boolean> {
    let params = new HttpParams().set('name', name);
    if (excludedId != null) {
      params = params.set('excludedId', String(excludedId));
    }

    return this.http
      .get<
        boolean | { isUnique?: boolean; data?: boolean }
      >(resolveUrl(`${CRM_SEGMENT}/check-name-unique`), { params })
      .pipe(
        map(response => {
          if (typeof response === 'boolean') {
            return response;
          }

          if (typeof response?.isUnique === 'boolean') {
            return response.isUnique;
          }

          if (typeof response?.data === 'boolean') {
            return response.data;
          }

          return false;
        }),
      );
  }
}
